export default function () {
  return {
    notas: null,
  };
}
